module.exports = __webpack_public_path__ + "static/kw51_img_4-91aad8711f5a581fd54c73680e506d25.png";